import { render, staticRenderFns } from "./ItemsInvoiceList.vue?vue&type=template&id=01d2febb&scoped=true&"
import script from "./ItemsInvoiceList.vue?vue&type=script&lang=js&"
export * from "./ItemsInvoiceList.vue?vue&type=script&lang=js&"
import style0 from "./ItemsInvoiceList.vue?vue&type=style&index=0&id=01d2febb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d2febb",
  null
  
)

export default component.exports